import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { createUsersByUsername, CreateUsersByUsernameOptions } from '~/monolith-api';

export type { CreateUsersByUsernameOptions };

const createUsersByUsernameSchema = z.object({
   usernames: z.array(z.string()),
});

export default createBFFHandlers({
   post: async (req, res) => {
      const { usernames } = createUsersByUsernameSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await createUsersByUsername({
         usernames: usernames,
         apiClient: monolithClient,
      });
      res.status(201).json(result);
   },
});

export const createUsersByUsernameFromClient = ({
   usernames,
}: CreateUsersByUsernameOptions): ReturnType<typeof createUsersByUsername> => {
   return bff()
      .post('/users/createUsersByUsername', {
         usernames,
      })
      .then(response => response.data);
};
